const mapResponse = (response) =>
    response
        .json()
        .catch(() => {
            throw {
                statusCode: response.status,
                headers: response.headers,
                error: null,
            };
        })
        .then((json) => {
            if (response.ok) {
                return json;
            }
            throw {
                statusCode: response.status,
                headers: response.headers,
                error: json,
            };
        });

const callApi = (request) => {
    const transformedRequest = {
        ...request,
        headers: { 'Content-Type': 'application/json' },
    };

    return fetch(request.url, transformedRequest).then(mapResponse);
};

export const getDefaultFacilityByLocation = (jsonObject) => async () => {
    let response;

    try {
        response = await callApi({
            url: `/api/projects/defaultfacility`,
            method: 'POST',
            body: JSON.stringify(jsonObject),
        });
    } catch {
        return null;
    }
    return response;
};
